import { Suspense } from 'react';
import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Layout from './components/Layout';
import { ProtectedRoute, PublicRoute } from './components/route/';
import AuthGate from './components/AuthGate/AuthGate';
import RoleRoute from './components/route/RoleRoute/RoleRoute';
import { AuthProvider, useAuth } from './context/auth/AuthContext';
import KeywordsICDView from './views/KeywordsICDView';
import KeywordsClassView from './views/KeywordsClassView';
import KeywordsCatalogsView from './views/KeywordsCatalogsView';
import DiagnosesView from './views/DiagnosesView';
import CatalogsView from './views/CatalogsView';
import DictionariesView from './views/DictionariesView';
import SettingsView from './views/SettingsView';
import FunctionsView from './views/FunctionsView';
import UserSettingsView from './views/UserSettingsView';
// import MappingsView from './views/MappingsView';
// import NavigationView from './views/NavigationView';
import OverLayLoader from './components/OverLayLoader';
import AddServiceCodeView from './views/actions_views/AddServiceCodeView';
import AddICDCodeView from './views/actions_views/AddICDCodeView';
import AddCatalogsCodeView from './views/actions_views/AddCatalogsCodeView';
import ServicesView from './views/ServicesView';
import LoginView from './views/LoginView';
import SignUpView from './views/SignUpView';

import PATH from './helpers/routes.json';

const DictionariesIndexRedirect = () => {
  const { user } = useAuth();
  const firstTab = Object.keys(PATH.dictionaries.tabs).find(
    tab => !PATH.dictionaries.adminOnlyTabs.includes(tab) || user?.is_superuser,
  );
  return (
    <Navigate
      to={PATH.dictionaries.tabs[firstTab] ?? PATH.services.primary}
      replace
    />
  );
};

const App = () => {
  return (
    <>
      <AuthProvider>
        <AuthGate>
          <Suspense fallback={<OverLayLoader />}>
            <Routes>
              {/* ---------- ПУБЛИЧНЫЕ ---------- */}
              <Route
                element={
                  <PublicRoute redirectTo={PATH.services.primary}>
                    <Layout />
                  </PublicRoute>
                }
              >
                <Route path="/login" element={<LoginView />} />
                <Route path="/signup" element={<SignUpView />} />
              </Route>
              {/* ---------- ПРИВАТНЫЕ ---------- */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                {/* редирект с / */}
                <Route
                  index
                  element={<Navigate to={PATH.services.primary} replace />}
                />
                {/* services */}
                <Route path={PATH.services.primary} element={<Outlet />}>
                  <Route index element={<ServicesView />} />
                  <Route
                    path="keywords/:codeId/"
                    element={<KeywordsClassView />}
                  />
                  <Route path="add" element={<AddServiceCodeView />} />
                </Route>
                {/* diagnoses */}
                <Route path={PATH.diagnoses.primary} element={<Outlet />}>
                  <Route index element={<DiagnosesView />} />
                  <Route
                    path="keywords/:codeId"
                    element={<KeywordsICDView />}
                  />
                  <Route path="add" element={<AddICDCodeView />} />
                </Route>
                {/* catalogs */}
                <Route path={PATH.catalogs.primary} element={<Outlet />}>
                  <Route index element={<CatalogsView />} />
                  <Route
                    path="keywords/:codeId"
                    element={<KeywordsCatalogsView />}
                  />
                  <Route path="add" element={<AddCatalogsCodeView />} />
                </Route>
                {/* functions */}
                <Route
                  path={PATH.functions.primary}
                  element={
                    <Navigate
                      to={PATH.functions.tabs.classification}
                      replace={true}
                    />
                  }
                />
                <Route
                  path={PATH.functions.primary + '/*'}
                  element={<FunctionsView />}
                />
                {/* dictionaries */}
                <Route
                  path={PATH.dictionaries.primary}
                  element={<DictionariesIndexRedirect />}
                />
                <Route
                  path={PATH.dictionaries.primary + '/*'}
                  element={<DictionariesView />}
                />

                {/* settings */}
                <Route
                  path={PATH.settings.primary}
                  element={
                    <Navigate to={PATH.settings.tabs.user} replace={true} />
                  }
                />
                <Route
                  path={PATH.settings.primary + '/*'}
                  element={
                    <RoleRoute onlyAdmin>
                      <SettingsView />
                    </RoleRoute>
                  }
                />

                {/* user */}
                <Route
                  path={PATH.user.primary}
                  element={
                    <RoleRoute onlyUser>
                      <UserSettingsView />
                    </RoleRoute>
                  }
                />

                {/* fallback */}
                <Route
                  path="*"
                  element={<Navigate to={PATH.services.primary} replace />}
                />
              </Route>
            </Routes>
          </Suspense>
        </AuthGate>
      </AuthProvider>

      <ToastContainer autoClose={3000} />
    </>
  );
};

export default App;
